// assets/js/components/revenue-calculator/steps/step-1.js
var ui = require("../ui");
var data = require("../data");
var intlData = require("../intl-data");

function render(state, locale) {
    var d = state.d;
    var countries = intlData.getCountries(locale);
    var categoryOptions = Object.keys(data.BIZ_TYPES);
    var typeOptions = d.businessCategory ? data.BIZ_TYPES[d.businessCategory] || [] : [];

    var html = ui.stepLabel(_t("Step 1 of 6")) + ui.h2(_t("Tell us about your business")) +
        ui.sub(_t("We use this to tailor your estimate and compare results with similar businesses."));

    html += ui.field({
        id: "rc-business-category", label: _t("Business category"), required: true,
        inner: ui.select({ id: "rc-business-category", value: d.businessCategory, options: data.options(categoryOptions) })
    });

    if (d.businessCategory) {
        html += ui.field({
            id: "rc-business-type", label: _t("Business type"), required: true,
            inner: ui.select({ id: "rc-business-type", value: d.businessType, options: data.options(typeOptions) })
        });
    }

    html += ui.field({
        id: "rc-country", label: _t("Country / region"), required: true,
        inner: ui.select({
            id: "rc-country", value: d.country,
            options: countries.map(function (c) { return { value: c.region, label: c.name }; })
        })
    });

    html += ui.field({
        id: "rc-currency", label: _t("Currency"), required: true,
        hint: _t("Auto-selected based on your country. You can change it if needed."),
        inner: ui.select({
            id: "rc-currency", value: d.currency, placeholder: _t("Select currency..."),
            options: intlData.getAllCurrencyCodes().map(function (code) {
                return { value: code, label: code + " (" + intlData.getCurrencySymbol(locale, code) + ") — " + intlData.getCurrencyName(locale, code) };
            })
        })
    });

    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions, locale) {
    var d = state.d;
    var countries = intlData.getCountries(locale);

    container.querySelector("#rc-business-category").addEventListener("change", function (e) {
        actions.setField("businessCategory", e.target.value);
        actions.setField("businessType", "");
        actions.rerender();
    });

    var typeEl = container.querySelector("#rc-business-type");
    if (typeEl) typeEl.addEventListener("change", function (e) { actions.setField("businessType", e.target.value); });

    container.querySelector("#rc-country").addEventListener("change", function (e) {
        var match = countries.filter(function (c) { return c.region === e.target.value; })[0];
        actions.setField("country", e.target.value);
        actions.setField("countryName", match ? match.name : "");
        actions.setField("currency", match ? match.currency : "");
        // Update the currency select in place instead of re-rendering: keyboard type-ahead
        // fires "change" on every letter, and a re-render rebuilt this select and dropped
        // its focus, so typing "Spa" landed on the wrong country (QA round 1, item 4).
        var currencyEl = container.querySelector("#rc-currency");
        if (currencyEl) currencyEl.value = d.currency;
    });

    container.querySelector("#rc-currency").addEventListener("change", function (e) {
        actions.setField("currency", e.target.value);
    });

    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        if (!d.businessCategory || !d.businessType || !d.country || !d.currency) {
            actions.showError(!d.businessCategory ? "rc-business-category" : !d.businessType ? "rc-business-type" : !d.country ? "rc-country" : "rc-currency", _t("Please complete all required fields."));
            return;
        }
        actions.setField("apptDuration", data.APPT_DUR[d.businessCategory] || 1);
        actions.setField("noShowRate", data.NS_RATES[d.businessCategory] || 0.10);
        state.step = 2;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
